module.exports = __webpack_public_path__ + "img/background.f555a6eb.jpg";